import { Eyebrow, Reveal } from "./Reveal";

const THEMES = [
  "Business Analysis",
  "Product Ownership",
  "Project / Delivery Leadership",
  "Requirements Engineering",
  "Agile Delivery",
  "Mobile & Digital Product Projects",
  "Stakeholder Management",
  "UAT",
];

export default function Experience() {
  return (
    <section
      id="experience"
      data-testid="experience-section"
      className="scroll-mt-24 border-y border-navy/10 bg-sage/30 py-24 md:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-6 md:grid-cols-12 md:gap-16 md:px-12">
        <div className="md:col-span-5">
          <Reveal>
            <Eyebrow>Experience</Eyebrow>
            <h2 className="mt-5 font-display text-4xl font-semibold leading-[1.15] tracking-tight md:text-5xl">
              17+ years across Business Analysis, Product Ownership and Agile
              Delivery.
            </h2>
          </Reveal>
        </div>
        <div className="md:col-span-7">
          <ul className="grid grid-cols-1 gap-x-10 sm:grid-cols-2">
            {THEMES.map((theme, i) => (
              <Reveal key={theme} delay={i * 0.04}>
                <li
                  data-testid={`experience-theme-${i}`}
                  className="flex items-center gap-4 border-b border-navy/15 py-5"
                >
                  <span className="font-display text-sm text-rust">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-base font-medium tracking-tight">
                    {theme}
                  </span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
